import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const TARGET = new Date("2026-10-24T09:00:00+03:00").getTime();

function calc() {
  const now = Date.now();
  const diff = Math.max(0, TARGET - now);
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);
  return { d, h, m, s };
}

// eslint-disable-next-line no-unused-vars
export default function Countdown({ dark = false, compact = false }) {
  const [t, setT] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  const parts = [
    { v: t.d, l: "Дни" },
    { v: t.h, l: "Часа" },
    { v: t.m, l: "Минути" },
    { v: t.s, l: "Секунди" },
  ];

  const numSize = compact
    ? "text-5xl sm:text-6xl lg:text-7xl"
    : "text-6xl sm:text-7xl lg:text-8xl";
  const num = `font-display ${numSize} display-tight text-[#F5892E] font-bold`;
  const lbl = "font-mono text-[10px] sm:text-xs uppercase tracking-[0.32em] text-[#F5EBD9]";
  const padY = compact ? "py-6 sm:py-7" : "py-8";

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
      data-testid="countdown"
      className={`relative bg-[#050d1e]/70 backdrop-blur border-2 border-[#F5892E]/60 rounded-2xl ${padY} px-5 sm:px-8 shadow-[0_20px_60px_-15px_rgba(245,137,46,0.4)]`}
    >
      <div className="flex items-center gap-3 mb-4 sm:mb-5">
        <span className="w-2.5 h-2.5 rounded-full bg-[#F5892E] animate-pulse" />
        <span className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.32em] text-[#F5892E] font-semibold">
          До събитието остават
        </span>
      </div>
      <div className="grid grid-cols-4 gap-3 sm:gap-6 lg:gap-8">
        {parts.map((p, i) => (
          <div
            key={i}
            className="flex flex-col items-baseline gap-2 sm:gap-3 border-l-2 border-[#F5892E]/30 pl-3 sm:pl-4 first:border-l-0 first:pl-0"
            data-testid={`countdown-${p.l.toLowerCase()}`}
          >
            <span className={num}>{String(p.v).padStart(2, "0")}</span>
            <span className={lbl}>{p.l}</span>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
